<template>
  <div id="app">
    <div class="loading" v-if="isLoading">
      <loading
        :active.sync="isLoading"
        :lock-scroll="true"
        background-color="rgba(0,0,0,.4)"
        color="#000"
      ></loading>
    </div>
    <!-- <Header /> -->
    <router-view :ambienteProducao="ambienteProducao"></router-view>
    <FixedInBottom />
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import Header from "./components/Header";
import Footer from "./components/Footer.vue";
import FixedInBottom from "./components/FixedInBottom.vue";

export default {
  name: "App",
  beforeMount() {
    if (location.href.startsWith("https://carrinho.nscpay.com.br")) {
      this.ambienteProducao = true;
    }
    const params = this.$route.query;
    if (Object.keys(params).length && params.clientID) {
      this.setProfile(params);
      this.addClientId(params.clientID);
      this.requestConfigs();
    } else {
      if (!this.ClientId) this.navigateTo("accessDenied");
      this.isLoading = false;
    }
  },
  mounted() {
    const consoleSignatureStyle =
      "font-size: 16px;" +
      "background: linear-gradient(to right, #57bfc7, #76dce4);" +
      "color: white;" +
      "text-align: center;" +
      "padding: 10px 15px;" +
      "width: 100%;" +
      "border-radius: 20px;";
    const consoleSignatureText = `%cCarrinho NSCPay - V. ${
      process.env.VUE_APP_VERSION
    } | ${this.ambienteProducao ? "prod" : "test"} 🎉`;
    console.log(consoleSignatureText, consoleSignatureStyle);
  },
  data() {
    return {
      isLoading: true,
      ambienteProducao: false,
    };
  },
  computed: {
    ...mapGetters(["profile", "ClientId", "CONFIGS", "products"]),
  },
  methods: {
    ...mapActions(["setProfile", "addClientId", "addConfigs", "addProducts"]),
    async requestConfigs() {
      const url = this.ambienteProducao
        ? "https://api.nscpay.com.br/v1"
        : "https://api-homologacao.nscpay.com.br/v1";

      await axios({
        method: "GET",
        url: `${url}/clientes/${this.ClientId}`,
      })
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            const configuracoes = response.data.retorno.cliente.configuracoes;
            // Adicionando configs formatadas...
            this.formatConfigs(response.data.retorno.cliente.configuracoes);

            // Adicionando cores...
            this.setDinamicColors();

            // Configurando página dinamicamente...
            this.setDinamicTitle();
            this.setDinamicFavicon();

            // Lista de produtos
            this.addProducts(configuracoes.pagamento.listaProdutos);

            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.error(error);
          this.msgCart(
            "error",
            "Ops...",
            "Não foi possível realizar a listagem dos produtos, por favor verifique sua conexão com a internet"
          );
          this.isLoading = false;
        });
    },
    formatConfigs(configs) {
      this.addConfigs({
        id: configs.cnpj,
        ...configs,
      });
    },
    msgCart(type, title, text) {
      this.$swal.fire({
        icon: type,
        title: title,
        text: text,
      });
    },
    navigateTo(name) {
      this.$router.push({ name });
    },

    setDinamicFavicon() {
      const link = document.querySelector("link[rel*='icon']");

      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      // link.href = this.CONFIGS.pagamento.faviconPagina;

      document.getElementsByTagName("head")[0].appendChild(link);
    },

    setDinamicTitle() {
      window.document.title = this.CONFIGS.pagamento.tituloPagina || "Carrinho - NSCPay";
    },

    setDinamicColors() {
      const root = document.documentElement;

      const analisarValorCampo = (campo) => {
        const value = this.CONFIGS.pagamento.cores[campo]
        return value != "null" ? value : null;
      };

      const adicionarCorTemaNavegador = () => {
        document.querySelector('meta[name="theme-color"]').content =
          analisarValorCampo("primaria") ?? "#E5E7E9";
      };

      root.style.setProperty(
        "--color-primary",
        analisarValorCampo("primaria") ?? "#E5E7E9"
      );
      root.style.setProperty(
        "--color-secondary",
        analisarValorCampo("secundaria") ?? "#cccccc"
      );

      root.style.setProperty(
        "--color-text-primary",
        analisarValorCampo("corTextoPrincipal") ?? "#000000"
      );
      root.style.setProperty(
        "--color-text-secondary",
        analisarValorCampo("corTextoSecundario") ?? "#ffffff"
      );

      root.style.setProperty(
        "--color-text-product-value",
        analisarValorCampo("primaria") ?? "#63f700"
      );
      root.style.setProperty(
        "--color-text-product-discount",
        analisarValorCampo("corTextoValorDescontoProduto") ?? "#FF2849"
      );

      root.style.setProperty(
        "--color-roll-up-button",
        analisarValorCampo("corBotaoRolarParaCima") ?? "#ffffff"
      );
      root.style.setProperty(
        "--color-icon-roll-up-button",
        analisarValorCampo("corIconeBotaoRolarParaCima") ?? "#000000"
      );

      root.style.setProperty(
        "--color-finalize-order-button",
        analisarValorCampo("primaria") ?? "#63f700"
      );
      root.style.setProperty(
        "--color-text-finalize-order-button",
        analisarValorCampo("corTextoBotaoFinalizarPedido") ?? "#ffffff"
      );

      root.style.setProperty(
        "--color-finish-order-button",
        analisarValorCampo("primaria") ?? "#63f700"
      );
      root.style.setProperty(
        "--color-text-finish-order-button",
        analisarValorCampo("corTextoBotaoEnvioPedido") ?? "#ffffff"
      );

      // Cores banner produto (aplicar, em modelo, para todos os clientes, possivelmente uma nova tabela de cores de produtos)
      root.style.setProperty(
        "--color-primary-product-banner",
        analisarValorCampo("corPrimariaBannerProduto") ?? "#dedede"
      );
      root.style.setProperty(
        "--color-secondary-product-banner",
        analisarValorCampo("corSecundariaBannerProduto") ?? "#bfbfbf"
      );

      // Cor do tema do navegador...
      adicionarCorTemaNavegador();
    },
  },
  components: {
    Loading,
    // Header,
    FixedInBottom,
    Footer,
  },
};
</script>
